// Names only — no third-party logo artwork is used anywhere here.
// Icons in the grid are auto-generated colored initials. When you
// wire up the real project, swap in actual wallet SDK logos/icons.
// Edit, add, or remove entries freely.
const ALL_WALLET_NAMES = [
  'MetaMask',
  'Ledger Wallet',
  'Uniswap Wallet',
  'Polkadot Wallet',
  'HashPack Wallet',
  'BankSocial Wallet',
  'Binance Wallet',
  'SafePal Wallet',
  'Fetch.ai Wallet',
  'Bifrost Wallet',
  'Ledger Live',
  'Zerion Wallet',
  'OKX Wallet',
  'Shido Wallet',
  'XUMM Wallet',
  'Coinbase Wallet',
  'GateWeb3 Wallet',
  'BitGet Wallet',
  'Robinhood Wallet',
  'ByBit Wallet',
  'Frontier Wallet',
  'Grove Wallet',
  'SafeMoon Wallet',
  'SaitaPro Wallet',
  'Phantom',
  'Enjin Wallet',
  'Blockchain.com Wallet',
  'MEW Wallet',
  'Rabby Wallet',
  'BRISE Wallet',
  "D'CENT Wallet",
  'Rainbow',
  'Trust Wallet',
  'Argent',
  'Gnosis Safe',
  'Equal Wallet',
  'MEET.ONE',
  'MoriX Wallet',
  'Brave Wallet',
  'Venly Wallet',
  'Crypto.com Wallet',
  'Pillar',
  'imToken',
  'ONTO',
  'TokenPocket',
  'MathWallet',
  'BitPay',
  'Walleth',
  'Authereum',
  'Dharma',
  '1inch Wallet',
  'Huobi Wallet',
  'Eidoo',
  'MYKEY',
  'Loopring Wallet',
  'TrustVault',
  'Atomic Wallet',
  'Coin98',
  'CoolWallet',
  'Alice',
  'AlphaWallet',
  'ZelCore',
  'Nash',
  'Nova Wallet',
  'Keplr Wallet',
  'FOX Wallet',
  'Ronin Wallet',
  'Coinomi',
  'GridPlus',
  'CYBAVO Wallet',
  'Tokenary',
  'Torus',
  'Spatium',
  'Infinito',
  'wallet.io',
  'Infinity Wallet',
  'BitVerse Wallet',
  'Solace Wallet',
  'Ownbit',
  'EasyPocket',
  'Bridge Wallet',
  'SparkPoint',
  'ViaWallet',
  'BitKeep',
  'Vision',
  'PEAKDEFI Wallet',
  'Unstoppable Wallet',
  'HaloDeFi Wallet',
  'Dok Wallet',
  'AT.Wallet',
  'Midas Wallet',
  'Ellipal',
  'KEYRING Pro',
  'Aktionariat',
  'Talken Wallet',
  'XinFin XDC Wallet',
  'Flare Wallet',
  'KyberSwap',
  'AToken Wallet',
  'Tongue Wallet',
  'RWallet',
  'PlasmaPay',
  'O3Wallet',
  'HashKey Wallet',
  'Jade Wallet',
  'Guarda Wallet',
  'Defiant',
  'Trustee Wallet',
  'Exodus',
];

export default ALL_WALLET_NAMES;